const state = {
  list: [],
  product: {}
};

const getters = {
  list: (state) => {
    return state.list || [];
  },
  product: (state) => {
    return state.product || {};
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_PRODUCT(state, item) {
    state.product = item;
  }
};

const actions = {
  getAllProducts({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('promo/getAllProducts')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`promo/getProduct?id=${id}`)
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  refreshProducts({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put('promo/refresh?id=null')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  refreshProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`promo/refresh?id=${id}`)
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  refreshProductByExternalId({ commit }, externalId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`promo/refreshByExternalId?externalId=${encodeURIComponent(externalId)}`)
        .then((response) => {
          commit('SET_PRODUCT', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
